/**
 * 解析 URL 白名单属性
 *
 * @param  {Object} data 数据源
 * @return {Object}
 */
export const parseUrlProps = (data = {}) => {
    const mapping = {};
    const props = [
        'href',
        'origin',
        'protocol',
        'port',
        'host',
        'hostname',
        'search',
        'hash',
        'pathname',
    ];
    props.forEach((key) => {
        mapping[key] = data[key] || '';
    });

    return mapping;
};

/**
 * 解析链接字符为对象
 *
 * @param  {string} url 链接
 * @return {Object}
 */
export const parseUrl = (url = '') => {
    try {
        return new URL(url);
    } catch (e) {
        const a = document.createElement('a');
        a.href = url;
        return parseUrlProps(a);
    }
};

/**
 * 获取URL参数
 * @param field 参数名
 * @returns
 */
export const getUrlQuery = (field: string) => {
    if (typeof window !== 'undefined') {
        const url = new URL(window?.location?.href || '');
        return url.searchParams.get(field) ?? '';
    }

    return '';
};

